import React, { Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { BarsArrowDownIcon, PencilIcon } from '@heroicons/react/24/outline'
import { changeAssignment } from '../../../../../../../reducers/meeting-type-task/constructor'
import { Menu, Transition } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import RenameSectionForm from '../rename-section-form/RenameSectionForm'
import { classNames } from '../../../../../../../utils/className'

export default function ListSection({
  section,
  index,
  saveContent,
  deleteSection,
  renamingSectionUuid,
  setRenamingSectionUuid,
}) {
  const dispatch = useDispatch()

  const changeAssignmentProcess = (event, index) => {
    dispatch(changeAssignment({ index, value: event.target.value }))
  }

  return (
    <div>
      <div className={'mb-4 flex flex-row justify-between'}>
        <div className={'flex items-center text-sm text-gray-500'}>
          <BarsArrowDownIcon className={'w-4 h-4 text-gray-500 mr-4'} />
          {renamingSectionUuid === section.uuid && (
            <RenameSectionForm section={section} sectionIndex={index} saveContent={saveContent} />
          )}
          {renamingSectionUuid !== section.uuid && (
            <>
              {section.name || 'List section'}
              <button
                type={'button'}
                onClick={(event) => {
                  setRenamingSectionUuid(section.uuid)
                }}
                className={'ml-1 p-1 rounded-md hover:bg-indigo-50'}
              >
                <PencilIcon className={'w-4 h-4 text-gray-400'} />
              </button>
              <span className={'pl-8 text-gray-300 text-sm'}>{section.uuid}</span>
            </>
          )}
        </div>
        <div>
          <Menu as="div" className="relative flex-none">
            <Menu.Button className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
              <span className="sr-only">Open options</span>
              <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                <Menu.Item>
                  {({ focus }) => (
                    <button
                      onClick={() => {
                        deleteSection(index)
                      }}
                      className={classNames(
                        focus ? 'bg-gray-50' : '',
                        'block w-full text-left px-3 py-1 text-sm leading-6 text-gray-900',
                      )}
                    >
                      Delete section
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
      <textarea
        placeholder={'Please provide an assignment for the AI just here...'}
        onChange={(event) => {
          changeAssignmentProcess(event, index)
        }}
        value={section.data.assignment || section.task}
        rows={8}
        className={'w-full rounded-md border-0 ring-1 text-sm text-gray-700'}
        name={`section-${index}-task`}
      />
    </div>
  )
}
